<!--
  カテゴリーカードに渡すべきもの
  - categories
    - title
    - q
      - q.text
      - ans(はい, 少し, いいえ)
      - comment (if need)
      - link(if need)
-->

<template>
  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
    <div class="card result-category-card">
      <!-- カテゴリタイトル -->
      <h2 class="card-header" v-text="category.title"></h2>
      <!-- 問題本文と回答、解説集 -->
      <div class="card-body category-card-item">
        <ul class="category-card-qlist">
          <li class="category-card-q" v-for="(q, j) in category.q" :key="j">
            <div class="accordion" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="card">
                <div class="card-header" role="tab" id="headingOne" :class="q.headerClass">
                    <a class="text-body d-block p-3 m-n3" data-toggle="collapse" :href="'#'+q.key" role="button" aria-expanded="true" aria-controls="collapseOne">
                      <p class="category-card-item-title"> {{ q.text }} - {{ q.ans }} </p>
                    </a>
                </div> <!-- /.card-header -->
                <div :id="q.key"  class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion" v-if="q.comment != null">
                  <div class="card-body">
                    <p v-text="q.comment"></p>
                    <router-link :to="q.link"  target="_blank" class="btn btn-info btn-lg" v-if="q.link" v-text="args.linkButton">
                    </router-link>
                  </div><!-- /.card-body -->
                </div><!-- /.collapse -->   
              </div><!-- /.card -->
            </div><!-- /#accordion -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: [
        'category',
        'args',
    ],
    computed: {
    },
    methods: {
    }
}
</script>

<style>


.category-card-item{
  cursor: pointer;
  margin-bottom: 4px;
}

.category-card-item-title {
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 0;
}

/* 各カテゴリーの問題リスト */
.category-card-qlist {
  list-style: none;
  margin: 0 0 0 0;
  padding: 0;
}

/* 各問題 */
.category-card-q {
  width: 100%;
}

/* 「はい」の場合 */
.good {
  border-color: #76FF03;
  background-color: #A5F6A7;
}

/* 「少し」の場合 */
.poor {
  border-color: #FFEE58;
  background-color: #FFF176;
}

/* 「いいえ」の場合 */
.bad {
  border-color: #FFAB91;
  background-color: #FFAB91;
}




.good > .panel-heading {
  color: #2A2A2A;
  background-color: #A5F6A7;
  border-color: #CCFF90;
}
.panel-good > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #76FF03;
}
.panel-good > .panel-heading .badge {
  color: #2A2A2A;
  background-color: #CCFF90;
}
.panel-good > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #000;
}

.panel-poor > .panel-heading {
  color: #2A2A2A;
  background-color: #FFF176;
  border-color: #FFEE58;
}
.panel-poor > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #FFEE58;
}
.panel-poor > .panel-heading .badge {
  color: #2A2A2A;
  background-color: #FFEE58;
}
.panel-poor > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #000;
}

.panel-bad > .panel-heading {
  color: #2A2A2A;
  background-color: #FFC3D2;
  border-color: #FFAB91;
}
.panel-bad > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #FFAB91;
}
.panel-bad > .panel-heading .badge {
  color: #2A2A2A;
  background-color: #FFAB91;
}
.panel-bad > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #000;
}



</style>